module.exports = __webpack_public_path__ + "static/media/logo_carta.fcdfd7d1.png";